<template>
	<div id="Property_Summary" class="property-summary">
		<div class="property-image">
			<PropertyImg :propertyId="property.id" />
		</div>
		<div class="property-info-details">
			<div class="summary-info">
				<div class="header5">Property</div>
				<div class="header3">Summary</div>
				<div class="header2">{{ property.address }}</div>
				<div class="property-pin">PIN: {{ property.pin }}</div>
			</div>

			<div class="summary-details">
				<SummaryTag tagLabel="City" :tagText="propertySummary.city.toString() | capitalizeName" />
				<SummaryTag tagLabel="Township" :tagText="property.township.toString() | capitalizeName" />
				<SummaryTag tagLabel="Age" :tagText="property.age.toString()" />
				<SummaryTag tagLabel="Exterior" :tagText="property.exteriorDescription" />
				<SummaryTag tagLabel="Land SqFt" :tagText="propertySummary.landSqft.toString() | numberWithCommas" />
				<SummaryTag tagLabel="Building SqFt" :tagText="property.buildingSqFt.toString() | numberWithCommas" />
				<SummaryTag tagLabel="Class" :tagText="getFormtatedClassInfo" />
			</div>

			<div v-if="property.assessmentRate !== assessmentStatusValue.notAssessed" class="button-cont" @click="yesButton">
				<i class="material-icons arrow-link">east</i>
				<div class="link-button">What is my property assessment?</div>
			</div>
		</div>
	</div>
</template>

<script>
import PropertyImg from "@/components/property/PropertyImg.vue";
import SummaryTag from "@/components/property/SummaryTag.vue";
import Button from "@/components/ui/Button.vue";
import { assessmentStatus } from "@/env";

export default {
	name: "property-summary",
	components: {
		PropertyImg,
		Button,
		SummaryTag,
	},
	data() {
		return {
			// moreSummaryInfo: false,
		};
	},
	computed: {
		propertySummary() {
			return this.$store.getters.getAllPropertyData.propertySummary;
		},
		// summaryTagMore() {
		// 	return this.$store.getters.getAllPropertyData.propertySummaryMore;
		// },
		property() {
			return this.$store.getters.getAllPropertyData;
		},
		getFormtatedClassInfo() {
			return `${this.$options.filters.propertyClassificationFormat(this.property.propertyClassification.toString())}
						${this.propertySummary.propertyType.toString()}`;
		},
		assessmentStatusValue() {
			return assessmentStatus;
		},
	},
	methods: {
		yesButton() {
			this.scroll("#Property_Assessment");
		},
		scroll(to) {
			const element = document.querySelector(to);
			let offset = 56;

			window.scrollTo({
				top: element.offsetTop - offset,
				left: 0,
				behavior: "smooth",
			});
		},
		noButton() {
			window.location = "mailto:info@garbur.com";
		},
	},
};
</script>

<style scoped lang="scss">
.property-summary {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
	padding: 60px;
	// padding-top: 120px;
	grid-gap: 30px;
	max-width: 1600px;
	position: relative;
	margin: 0 auto;
	.property-info-details {
		.summary-info {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			.header5 {
				color: var(--accent);
			}
			.header3 {
				font-size: 36px;
				line-height: 36px;
				color: var(--black);
				margin-top: 8px;
			}
			.header2 {
				margin-top: 36px;
				margin-bottom: 5px;
				font-size: 40px;
				line-height: 100%;
				color: var(--black);
				// width: 660px;
				text-align: left;
			}
			.property-pin {
				font-weight: 500;
				font-size: 18px;
				line-height: 27px;
				color: var(--text);
				margin-bottom: 33px;
			}
		}
		.summary-details {
			display: grid;
			// grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
			grid-template-columns: repeat(auto-fit, minmax(317px, 1fr));
		}
		.summary-tag:last-child {
			display: grid;
			grid-column: span 2;
			text-align: left;
		}
		.summary-tag:nth-child(even) .detail-item .label-cont {
			// width: 135px;
		}
		.link-button {
			color: var(--accent);
			margin-top: 8px;
			font-weight: 500;
			font-size: 18px;
			cursor: pointer;
			border-bottom: 2px solid var(--accent);
			line-height: 30px;
		}
		.arrow-link {
			background: var(--accent);
			color: white;
			border-radius: 20px;
			margin-left: 10px;
			padding: 6px;
			cursor: pointer;
		}
		.button-cont {
			text-align: left;
			display: flex;
			flex-direction: row-reverse;
			margin-top: 50px;
			align-items: flex-end;
		}
	}
}
@media screen and (max-width: 768px) {
	.property-summary {
		height: unset;
	}
}
@media screen and (max-width: 414px) {
	.property-summary {
		padding: unset;
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(372px, 1fr));
		.property-image .property-img {
			height: unset;
			img {
				width: 100%;
				height: auto;
			}
		}
		.property-info-details {
			padding: 3rem 1rem;
			.summary-tag:last-child {
				display: grid;
				grid-column: unset;
			}
			.summary-info .header2 {
				font-size: 2.5rem;
			}
		}
	}
}
</style>
